import React, { useEffect, useState } from 'react';
import LineGradient from '../components/LineGradient';
import useMediaQuery from '../hooks/useMediaQuery';
import Contact from './Contact';
import DotGroup from './DotGroup';
import Footer from './Footer';
import Navbar from './Navbar';
import { motion } from "framer-motion";
import Landing from './Landing';
import AboutMe from './AboutMe';
import ProjectHome from './ProjectHome';
import Experience from './Experience';
import MySkill from './MySkill';
import InternWorks from './InternWork';
import ClientWorks from './ClientWorks';


const Home = () => {
    const [selectedPage, setSelectedPage] = useState("home");
    const [isTopOfPage, setIsTopOfPage] = useState(true);
    const isDesktop = useMediaQuery("(min-width: 1060px)");

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY === 0) {
                setIsTopOfPage(true);
                setSelectedPage("home");
            }
            if (window.scrollY !== 0) setIsTopOfPage(false);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    return (
        <div>
            <div className="app bg-deep-blue">
                <Navbar
                    isTopOfPage={isTopOfPage}
                    selectedPage={selectedPage}
                    setSelectedPage={setSelectedPage}
                />
                <div className="w-5/6 mx-auto md:h-full">
                    {isDesktop && (
                        <DotGroup
                            selectedPage={selectedPage}
                            setSelectedPage={setSelectedPage}
                        />
                    )}
                    <motion.div
                        margin="0 0 -200px 0"
                        amount="all"
                        onViewportEnter={() => setSelectedPage("home")}
                    >
                        <Landing setSelectedPage={setSelectedPage} />
                    </motion.div>
                </div>
                <LineGradient />
                <div className="w-5/6 mx-auto md:h-full ">
                    <motion.div
                        margin="0 0 -200px 0"
                        amount="all"
                        onViewportEnter={() => setSelectedPage("about")}
                    >
                        <AboutMe />
                    </motion.div>
                </div>
                <LineGradient />
                <div className="w-5/6 mx-auto md:h-full ">
                    <motion.div
                        margin="0 0 -200px 0"
                        amount="all"
                        onViewportEnter={() => setSelectedPage("experience")}
                    >
                        <Experience />
                    </motion.div>
                </div>
                <div className="w-5/6 mx-auto md:h-full">
                    <motion.div
                        margin="0 0 -200px 0"
                        amount="all"
                        onViewportEnter={() => setSelectedPage("internworks")}
                    >
                        <InternWorks />
                    </motion.div>
                </div>
                <div className="w-5/6 mx-auto md:h-full">
                    <motion.div
                        margin="0 0 -200px 0"
                        amount="all"
                        onViewportEnter={() => setSelectedPage("internworks")}
                    >
                        <ClientWorks />
                    </motion.div>
                </div>
                <LineGradient />
                <div className="w-5/6 mx-auto md:h-full">
                    <motion.div
                        margin="0 0 -200px 0"
                        amount="all"
                        onViewportEnter={() => setSelectedPage("projects")}
                    >
                        <ProjectHome />
                    </motion.div>
                </div>

                <LineGradient />


                <div className="w-5/6 mx-auto md:h-full ">
                    <motion.div
                        margin="0 0 -200px 0"
                        amount="all"
                        onViewportEnter={() => setSelectedPage("myskills")}
                    >
                        <MySkill />
                    </motion.div>
                </div>
                <LineGradient />
                <div className="w-5/6 mx-auto md:h-full">
                    <motion.div
                        margin="0 0 -200px 0"
                        amount="all"
                        onViewportEnter={() => setSelectedPage("contact")}
                    >
                        <Contact />
                    </motion.div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default Home;